import { render, staticRenderFns } from "./modal.vue?vue&type=template&id=4845a954&scoped=true"
import script from "./modal.vue?vue&type=script&lang=ts"
export * from "./modal.vue?vue&type=script&lang=ts"
import style0 from "./modal.less?vue&type=style&index=0&id=4845a954&prod&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4845a954",
  null
  
)

export default component.exports